/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

/**
 * Cover the modal that contains the pressed button with a loader
 * @param {jQuery} $button - pressed button
 * @returns {Function} function that removes the loader
 */
const lockModal = function ($button) {
  const $host = sorHelpers.sorLoader.getModalHost($button);
  sorHelpers.sorLoader.start($host);
  return function () {
    sorHelpers.sorLoader.stop($host);
  };
};

const initUpdateProductQuantity = function () {
  $(document).on('click', '.update-item', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();

      const url = $(this).attr('data-link');
      const item = sorHelpers.sorUtils.getURLParameter(url, 'item');
      const quantity = $(this)
        .parents('.order-section')
        .find('#quantity_' + item)
        .val();
      const existingQuantity = $(this).data('qty');

      if (existingQuantity === +quantity) {
        return;
      }

      const stopLoader = lockModal($(this));
      $.ajax({
        type: 'POST',
        url: url,
        data: {
          quantity: quantity
        }
      })
        .done(function (response) {
          if (response) {
            if ($('#qtyError').length) {
              $('#qtyError').remove();
            }
            if (response.success) {
              window.location = SmartOrderRefillSettings.Urls.manageOrders;
            } else if (!$('#qtyError').length) {
              stopLoader();
              $('<label class="error" id="qtyError">' + response.message + '</label>').insertAfter('#quantity_' + item);
            }
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

const initRemoveProduct = function () {
  $(document).on('click', '.remove-item', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      const url = $(this).attr('data-link');
      const stopLoader = lockModal($(this));
      $.ajax({
        type: 'POST',
        url: url
      })
        .done(function (response) {
          if (response.success) {
            window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

const initUpdateRefill = function () {
  $(document).on('click', '.update-refill', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      const url = $(this).attr('data-link');
      const itemID = sorHelpers.sorUtils.getURLParameter(url, 'item');
      const selectedOption = $('#select-everydelivery-' + itemID).children('option:selected');
      const data = {
        periodicity: sorHelpers.sorValidation.sanitizeString(selectedOption.attr('data-periodicity')),
        interval: sorHelpers.sorValidation.sanitizeString(selectedOption.val())
      };

      const existingPeriodicy = sorHelpers.sorValidation.sanitizeString($('#select-everydelivery-' + itemID).data('periodicity'));
      const existingInterval = sorHelpers.sorValidation.sanitizeString($('#select-everydelivery-' + itemID).data('interval'));

      if (existingPeriodicy === data.periodicity && existingInterval === +data.interval) {
        return;
      }

      const stopLoader = lockModal($(this));
      $.ajax({
        type: 'POST',
        url: url,
        data: data
      })
        .done(function (response) {
          if (response && response.success) {
            window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

// Joint call between update quantity and update refill
const initUpdateQuantityRefill = function () {
  $(document).on('click', '.update-quantity-refill', function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      let url = $(this).attr('data-link');
      const itemID = sorHelpers.sorUtils.getURLParameter(url, 'item');
      const selectedOption = $('#select-everydelivery-' + itemID).children('option:selected');
      const quantity = $(this)
        .parents('.order-section')
        .find('#quantity_' + itemID)
        .val();
      const data = {
        quantity: quantity
      };

      const orderId = $(this).data('oid');
      const subscriptionId = $(this).data('sid');

      const hasIntervalChanged = !selectedOption.hasClass('start-interval-value');
      if (hasIntervalChanged) {
        // If the interval has changed, update the whole subscription
        data.periodicity = sorHelpers.sorValidation.sanitizeString(selectedOption.attr('data-periodicity'));
        data.interval = sorHelpers.sorValidation.sanitizeString(selectedOption.val());
        url = url.concat('&sid=' + subscriptionId);
      } else {
        url = url.replace('action=updateQuantityRefill', 'action=updateQuantity');
        // For quantity-only updates, update the order if orderId is present, otherwise update the subscription
        if (orderId) {
          url = url.concat('&oid=' + orderId);
        } else {
          url = url.concat('&sid=' + subscriptionId);
        }
      }

      const stopLoader = lockModal($(this));
      $.ajax({
        type: 'POST',
        url: url,
        data: data
      })
        .done(function (response) {
          if (response) {
            if ($('#qtyError').length) {
              $('#qtyError').remove();
            }
            if (response.success) {
              window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
            } else if (!$('#qtyError').length) {
              stopLoader();
              $('<label class="error" id="qtyError">' + response.message + '</label>').insertAfter('#quantity_' + itemID);
            }
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_QUANTITY_ERROR, false);
          }
        })
        .fail(function (err) {
          if (err.responseJSON && err.responseJSON.redirectURL) {
            window.location.href = err.responseJSON.redirectURL;
          } else {
            stopLoader();
            sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
          }
        });
    }
  });
};

const SOR_MODAL_ROOT_IDS = ['#sorModalCenter', '#orderview', '#subscriptionview'];

/**
 * Builds a comma-separated selector scoped to each SOR modal root.
 * @param {string} suffix descendant selector (without leading space)
 * @returns {string}
 */
const buildSorModalSelector = function (suffix) {
  return SOR_MODAL_ROOT_IDS.map(function (root) {
    return root + ' ' + suffix;
  }).join(', ');
};

const updateSorProductOosAlert = function ($input) {
  if (!$input || !$input.length) {
    return;
  }

  const availableQty = parseInt($input.attr('data-available-qty'), 10);
  const selectedQty = parseInt($input.val(), 10) || 0;
  const $wrapper = $input.closest('.side-info').find('.product-oos-alert-wrapper');

  if (!$wrapper.length || isNaN(availableQty)) {
    return;
  }

  $wrapper.toggleClass('d-none', selectedQty <= availableQty);
};

const refreshSorProductOosAlertsIn = function ($root) {
  if (!$root || !$root.length) {
    return;
  }

  $root.find('.side-info .input-quantity[data-available-qty]').each(function () {
    updateSorProductOosAlert($(this));
  });
};

const initProductAvailabilityAlert = function () {
  const quantitySelector = buildSorModalSelector('.side-info .input-quantity[data-available-qty]');
  const counterSelector = buildSorModalSelector('.side-info .increase') + ', ' + buildSorModalSelector('.side-info .decrease');

  $(document).on('change input', quantitySelector, function () {
    updateSorProductOosAlert($(this));
  });

  $(document).on('click', counterSelector, function () {
    const $button = $(this);
    window.setTimeout(function () {
      updateSorProductOosAlert($button.siblings('.input-quantity'));
    }, 0);
  });

  $(document).on('shown.bs.modal', '#sorModalCenter', function () {
    refreshSorProductOosAlertsIn($(this));
  });

  $(document).on('dialogopen', function (event) {
    const $dialog = $(event.target);
    if ($dialog.is('#orderview, #subscriptionview')) {
      refreshSorProductOosAlertsIn($dialog);
    }
  });
};

const initSwitch = function () {
  $(document).on('click', '.switch-button-container', function (e) {
    e.preventDefault();
    if (e.currentTarget.hasAttribute('aria-disabled') && e.currentTarget.ariaDisabled === 'true') {
      $('.register-button').addClass('flashing');
      setTimeout(function () {
        $('.register-button').removeClass('flashing');
      }, 1000);
    }

    if (e.currentTarget.hasAttribute('aria-disabled') && e.currentTarget.ariaDisabled === 'false') {
      $(e.currentTarget).find('.sor-switch').toggleClass('active');
    }

    if ($(e.currentTarget).find('.sor-switch').hasClass('active')) {
      $('input.sor-radio-button[data-type=onetime]').prop('checked', false);
      $('input.sor-radio-button[data-type=regular]').prop('checked', true);
      $('input.sor-radio-button').trigger('change');
      $('.value-shipping').data('value', $('.value-shipping').data('value-sor'));
    } else {
      $('input.sor-radio-button[data-type=onetime]').prop('checked', true);
      $('input.sor-radio-button[data-type=regular]').prop('checked', false);
      $('input.sor-radio-button').trigger('change');
      $('.value-shipping').data('value', $('.value-shipping').data('value-default'));
    }
  });
};

module.exports = {
  initUpdateProductQuantity: initUpdateProductQuantity,
  initRemoveProduct: initRemoveProduct,
  initUpdateRefill: initUpdateRefill,
  initUpdateQuantityRefill: initUpdateQuantityRefill,
  initProductAvailabilityAlert: initProductAvailabilityAlert,
  refreshSorProductOosAlertsIn: refreshSorProductOosAlertsIn,
  initSwitch: initSwitch
};
